// Español — mirrors en.js key for key. es distinguishes one/other in CLDR.
const es = {
  // ===== shared =====
  'common.createPlan': 'Crear plan',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.retry': 'Reintentar',
  'common.activate': 'Activar',
  'common.deactivate': 'Desactivar',
  'common.enabled': 'Activado',
  'common.disabled': 'Desactivado',
  'common.viewTerms': 'Ver términos',
  'common.untitledPlan': 'Plan sin título',
  'common.savedToast': 'Guardado correctamente',

  // ===== nav / chrome =====
  'nav.home': 'Inicio',
  'nav.plans': 'Planes',
  'nav.settings': 'Configuración',

  'mismatch.title': 'Entorno de despliegue no coincide',
  'mismatch.body': 'Esta compilación del frontend llama a {apiBase}, pero se sirve desde {hostname} (esperado: {expected}).',
  'mismatch.contact': 'Contacta con soporte técnico: se trata de un error de configuración de despliegue, no de un problema con tu cuenta.',

  'install.title': 'No se pudo conectar con Shopify',
  'install.body': 'Comprueba que el backend esté en ejecución y que su SHOPIFY_API_KEY coincida con el client_id de la app en shopify.app.toml.',
  'install.retry': 'Reintentar',

  'chrome.loadingBrand': 'Cargando FlexCover…',
  'error.title': 'Algo salió mal',
  'error.reload': 'Recargar',

  'support.badge': 'Vista de soporte',
  'support.shopUnknown': '(tienda desconocida)',
  'support.expired': 'Token caducado: regenera en la consola de soporte',
  'support.validUntil': 'Token válido hasta {time}',
  'support.exit': 'Salir',

  // ===== Home =====
  'home.title': 'Te damos la bienvenida a FlexCover: Protection Plans 👋',
  'home.last30days': 'Últimos 30 días',
  'home.loadingChart': 'Cargando el gráfico',
  'home.loadingOverview': 'Cargando el resumen',
  'home.statOrders': 'Pedidos con planes',
  'home.statRevenue': 'Ingresos totales de planes',
  'home.gettingStarted': 'Primeros pasos',
  'home.allSet': '¡Todo listo! 🎉',
  'home.completed': '{done} de {total} completados',
  'home.step1.title': 'Crea tu primer plan',
  'home.step1.desc': 'Configura el precio, la cobertura y el aspecto en el carrito de tu oferta de protección.',
  'home.step2.title': 'Activa el bloque de la app',
  'home.step2.desc': 'Activa el bloque FlexCover: Protection Plans para que el widget aparezca en tu carrito.',
  'home.step2.enable': 'Activar bloque de la app',
  'home.step2.check': 'Comprobar estado',
  'home.step3.title': 'Consigue tu primer pedido protegido',
  'home.step3.desc': 'Con el widget activo, los clientes añaden un plan en el carrito; los totales se muestran en las tarjetas de arriba.',
  'home.appEmbed': 'Bloque de la app',
  'home.checkingEmbed': 'Comprobando el estado del bloque de la app',
  'home.embedEnabledBody': 'El widget de protección está activo en tu tienda.',
  'home.embedTheme': '(tema: {theme})',
  'home.embedDisabledBody': 'La app no está activa actualmente en tu tienda.',
  'home.embedUnknown': 'Desconocido',
  'home.embedUnknownBody': 'El estado de la tienda estará disponible cuando la app esté conectada a una tienda.',
  'home.embedUnknownReason': 'No se pudo leer tu tema en este momento.',
  'home.enableEmbedHint': 'En el admin de Shopify, ve a Tienda online → Temas → Personalizar → Bloques de la app y activa FlexCover: Protection Plans.',
  'home.learnMorePrefix': 'Más información sobre ',
  'home.learnMoreLink': 'cómo usar los planes de protección',

  // ===== Plans list =====
  'plans.title': 'Planes',
  'plans.loading': 'Cargando planes',
  'plans.errorTitle': 'No se pudieron cargar los planes',
  'plans.empty.heading': 'Crea tu primer plan de protección',
  'plans.empty.body': 'Ofrece protección de envío, garantías extendidas, seguro de devolución y cobertura personalizada, todo con los precios que tú eliges.',
  'plans.loadDemo': 'Cargar planes de demostración',
  'plans.demoLoaded': 'Planes de demostración cargados',
  'plans.demoFailed': 'Error al cargar los planes de demostración: {message}',
  'plans.filterPlaceholder': 'Filtrar planes',
  'plans.addFilter': 'Añadir filtro',
  'plans.statusHeading': 'Estado',
  'plans.typeHeading': 'Tipo de protección',
  'plans.statusActive': 'Activo',
  'plans.statusInactive': 'Inactivo',
  'plans.showing_one': 'Mostrando {count} plan',
  'plans.showing_other': 'Mostrando {count} planes',
  'plans.sortBy': 'Ordenar por',
  'plans.selectAll': 'Seleccionar todos los planes',
  'plans.selectedCount': '{count} seleccionados',
  'plans.bulkDeleted_one': '{count} plan eliminado',
  'plans.bulkDeleted_other': '{count} planes eliminados',
  'plans.bulkActivated_one': '{count} plan activado',
  'plans.bulkActivated_other': '{count} planes activados',
  'plans.bulkDeactivated_one': '{count} plan desactivado',
  'plans.bulkDeactivated_other': '{count} planes desactivados',
  'plans.deleteBulkFailed': 'Error al eliminar: {message}',
  'plans.updateBulkFailed': 'Error al actualizar: {message}',
  'plans.activated': 'Plan activado',
  'plans.deactivated': 'Plan desactivado',
  'plans.updateFailed': 'Error al actualizar el plan: {message}',
  'plans.deleted': 'Plan eliminado',
  'plans.deleteFailed': 'Error al eliminar el plan: {message}',
  'plans.actionsFor': 'Acciones para {name}',
  'plans.activatePlan': 'Activar {name}',
  'plans.deactivatePlan': 'Desactivar {name}',
  'plans.onlineStore': 'Tienda online',
  'plans.optional': 'Opcional',
  'plans.automatic': 'Automático',
  'plans.noMatch': 'Ningún plan coincide con tu búsqueda o filtros.',
  'plans.deleteTitle': '¿Eliminar el plan de protección?',
  'plans.deleteBody': 'se eliminará de inmediato de tu tienda. Los clientes ya no verán esta opción de protección.',
  'plans.helpPrefix': '¿Necesitas ayuda? ',
  'plans.helpLink': 'Escríbenos',
  'plans.helpSuffix': ' o consulta la documentación y los tutoriales de la app.',

  'sort.date': 'Fecha (más recientes primero)',
  'sort.name': 'Nombre (A–Z)',
  'sort.sortOrder': 'Orden en el carrito',
  'sort.price': 'Precio (de menor a mayor)',

  'planType.shipping_protection': 'Protección de envío',
  'planType.warranty': 'Garantía',
  'planType.return_insurance': 'Seguro de devolución',
  'planType.custom': 'Protección personalizada',
  'planTypeShort.shipping_protection': 'Envío',
  'planTypeShort.warranty': 'Garantía',
  'planTypeShort.return_insurance': 'Devolución',
  'planTypeShort.custom': 'Personalizada',
  'priceType.fixed': 'Importe fijo',
  'priceType.percentage': 'Porcentaje del pedido',

  // ===== Plan editor page shell =====
  'plan.pageTitle': 'Plan de protección',
  'plan.loading': 'Cargando plan',
  'plan.notFound.heading': 'Plan no encontrado',
  'plan.notFound.body': 'Es posible que este plan de protección se haya eliminado.',
  'plan.backToPlans': 'Volver a los planes',
  'plan.newTitle': 'Nuevo plan de protección',
  'plan.newSubtitle': 'Configura el precio y el aspecto en el carrito y crea el plan',
  'plan.subtitle': 'Los cambios se aplican a tu tienda después de guardar',
  'plan.statusTitle': 'Estado del plan',
  'plan.saveFailed': 'Error al guardar el plan: {message}',

  // ===== Plan editor form =====
  'form.section.type': 'Tipo de protección',
  'form.section.basics': 'Datos básicos del plan',
  'form.section.pricing': 'Tarifa: {type}',
  'form.pricingFallback': 'Protección',
  'form.section.appearance': 'Apariencia',
  'form.section.fulfillment': 'Preparación',

  'form.type.shipping_protection': 'Protección de envío',
  'form.type.shipping_protection.help': 'Protege el pedido del cliente contra pérdida, daños o robo durante el envío.',
  'form.type.warranty': 'Garantía',
  'form.type.warranty.help': 'Cubre defectos de fabricación y desgaste normal durante un periodo determinado.',
  'form.type.return_insurance': 'Seguro de devolución',
  'form.type.return_insurance.help': 'Permite a los clientes devolver artículos dentro de un plazo para un reembolso completo.',
  'form.type.custom': 'Protección personalizada',
  'form.type.custom.help': 'Tu propio mensaje de cobertura personalizado.',

  'form.defaults.untitledPlan': 'Plan sin título',
  'form.defaults.viewTerms': 'Ver términos',
  'form.defaults.shipping_protection.displayName': 'Protección de envío',
  'form.defaults.shipping_protection.description': 'Protege tu pedido contra pérdida, daños o robo durante el envío.',
  'form.defaults.warranty.displayName': 'Garantía extendida',
  'form.defaults.warranty.description': 'Cubre defectos de fabricación y desgaste normal durante 2 años.',
  'form.defaults.return_insurance.displayName': 'Seguro de devolución',
  'form.defaults.return_insurance.description': 'Devuelve cualquier artículo dentro de 14 días y recibe un reembolso completo.',
  'form.defaults.custom.displayName': 'Plan de protección',
  'form.defaults.custom.description': 'Añade protección a tu pedido.',

  'form.lang.select': 'Seleccionar idioma',
  'form.lang.default': '{name} (predeterminado)',
  'form.translated': '(traducido)',

  'form.field.planName.label': 'Nombre del plan (interno)',
  'form.field.planName.help': 'Solo para tu referencia; los clientes nunca lo ven',
  'form.field.nameRequired': 'El nombre interno es obligatorio',
  'form.field.displayName.label': 'Nombre para mostrar',
  'form.field.displayNameRequired': 'El nombre para mostrar es obligatorio',
  'form.field.displayName.placeholder': 'Nombre para mostrar',
  'form.field.displayName.help': 'Se muestra a los clientes en el carrito y en el pago',
  'form.field.displayName.helpPreset': 'Se muestra a los clientes que navegan en {lang}',
  'form.field.displayName.helpPresetFallback': 'Se muestra a los clientes que navegan en {lang}; los campos vacíos recurren a {primary}',
  'form.field.description.label': 'Descripción',
  'form.field.description.placeholder': 'Descripción',
  'form.field.description.help': 'Breve descripción para los clientes que aparece bajo el nombre del plan',
  'form.field.disabledDescription.label': 'Descripción cuando no está seleccionado',
  'form.field.disabledDescription.placeholder': 'Opcional: se muestra cuando el plan no está seleccionado',
  'form.field.disabledDescription.help': 'Se muestra cuando la casilla del plan está desmarcada (si está vacío, recurre a la descripción anterior)',
  'form.field.footer.label': 'Pie de página',
  'form.field.footerText.label': 'Texto del pie de página',
  'form.field.footerLink.label': 'Enlace del pie de página',
  'form.field.footerLink.help': 'Destino del enlace del texto del pie de página',

  'form.price.type.label': 'Tipo de precio',
  'form.price.fixed': 'Importe ($)',
  'form.price.percentage': 'Porcentaje (%)',
  'form.price.advanced': 'Ajuste avanzado',
  'form.price.pctSummary': '{pct}% del importe del pedido, desde ${min} en incrementos de ${inc} hasta ${max}; {count} variantes en el producto del plan',
  'form.price.tiersSummary_one': 'El producto del plan obtiene 1 variante en {base} más {count} variante por intervalos para las reglas de valor del carrito',
  'form.price.tiersSummary_other': 'El producto del plan obtiene 1 variante en {base} más {count} variantes por intervalos para las reglas de valor del carrito',

  'form.validation.priceRequired': 'Introduce un valor mayor que 0',
  'form.validation.priceMax100': 'El porcentaje no puede superar 100',
  'form.validation.warrantyYears': 'Introduce una duración de entre 1 y 5 años',
  'form.validation.returnDays': 'Introduce un plazo de entre 7 y 365 días',
  'form.validation.maxGreaterThanMin': 'El máximo debe ser mayor que el mínimo',
  'form.validation.variantIdNumeric': 'El ID de variante debe ser numérico (el ID de la variante oculta del plan)',

  'form.icon.label': 'Icono',
  'form.icon.useEmoji': 'Usar {emoji} como icono del plan',
  'form.icon.removeCustom': 'Quitar el icono personalizado y usar el icono de escudo',
  'form.icon.upload': 'Subir una imagen de icono personalizada',
  'form.icon.uploadButton': 'Subir',
  'form.icon.uploading': 'Subiendo el icono',
  'form.icon.uploadHelp': 'Sube tu propio icono: PNG, JPEG, GIF o WebP, hasta 5 MB.',
  'form.icon.error.notImage': 'Elige un archivo de imagen (PNG, JPEG, GIF o WebP).',
  'form.icon.error.tooLarge': 'La imagen debe ser de 5 MB o menos.',

  'form.fulfillment.intro': 'Elige cuándo se marca como preparado el producto de protección.',
  'form.fulfillment.manually': 'Preparar manualmente',
  'form.fulfillment.first_item': 'Marcar como preparado cuando se prepare el primer artículo del pedido',
  'form.fulfillment.all_items': 'Marcar como preparado cuando se preparen todos los demás artículos del pedido',
  'form.fulfillment.immediately': 'Marcar como preparado inmediatamente después de crear el pedido',

  'form.adv.title': 'Ajuste avanzado',
  'form.adv.minPrice': 'Precio mínimo',
  'form.adv.minPriceHelp': 'El precio de la primera variante; la tarifa mínima que cobra el plan',
  'form.adv.increment': 'Importe del incremento',
  'form.adv.incrementHelp': 'Escalón de precio entre las variantes generadas',
  'form.adv.maxPriceLabel': 'Precio máximo: ',
  'form.adv.explanation': 'El producto del plan se genera con {buckets} variantes: el precio mínimo {min} ocupa una variante y las {rest} variantes restantes suben en incrementos de {inc}, hasta un precio máximo de {max}. En el pago, el cliente paga la primera variante con precio igual o superior al {pct}% del subtotal del carrito; un carrito de $100 al 2% apunta a $2.00, por lo que se aplica la variante de $3.01. ',
  'form.learnMore': 'Más información',

  'form.tiers.title': 'Fijar precio por valor del carrito',
  'form.tiers.minCol': 'Valor mínimo del carrito',
  'form.tiers.maxCol': 'Valor máximo del carrito',
  'form.tiers.priceCol': 'Precio de la protección',
  'form.tiers.addTier': 'Añadir nuevo tramo',
  'form.tiers.deleteTier': 'Eliminar tramo {index}',
  'form.tiers.explanation': 'Cada regla necesita un mínimo, un máximo y un precio (las reglas pueden solaparse; se aplica la primera que coincida). Cada regla se convierte en su propia variante del producto del plan. Si el total del carrito no coincide con ninguna regla, se aplica el precio fijo del ajuste principal. ',
  'form.tiers.error.minRequired': 'El valor mínimo del carrito es obligatorio',
  'form.tiers.error.maxRequired': 'El valor máximo del carrito es obligatorio',
  'form.tiers.error.priceRequired': 'El precio de la protección es obligatorio',
  'form.tiers.error.pricePositive': 'El precio debe ser mayor que 0',
  'form.tiers.error.minMax': 'El mínimo debe ser menor o igual que el máximo',

  // ===== Save bar =====
  'savebar.unsavedChanges': 'Cambios sin guardar',
  'savebar.discard': 'Descartar',
  'savebar.saving': 'Guardando…',

  // ===== Preview panel =====
  'preview.title': 'Vista previa',
  'preview.simulatedSubtotal': 'Subtotal simulado del carrito',
  'preview.cart': 'Carrito',
  'preview.product': 'PRODUCTO',
  'preview.total': 'TOTAL',
  'preview.subtotal': 'Subtotal',
  'preview.checkout': 'Finalizar compra',
  'preview.noPlans': 'Aún no hay planes activos; los clientes no verán este widget.',
  'preview.autoAdded': 'Añadido automáticamente',
  'preview.unsaved': 'Sin guardar',

  // ===== Settings page =====
  'settings.title': 'Configuración',
  'settings.language.title': 'Preferencia de idioma',
  'settings.language.help': 'Cuando visites FlexCover, este es el idioma que se te mostrará. El idioma de tu tienda no se ve afectado.',
  'settings.language.label': 'Idioma',
  'settings.language.updated': 'Idioma actualizado',
  'settings.language.saveFailed': 'Error al guardar la preferencia de idioma: {message}'
};

export default es;
